// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".osui-empty .ant-empty-image{margin-bottom:4px}.osui-empty .ant-empty-description{color:var(--color-gray-9)}.osui-empty .osui-empty-large .ant-empty-image{height:auto;margin-bottom:20px}.osui-empty .osui-empty-large .ant-empty-image svg{height:100%;max-width:360px;min-width:180px}.osui-empty .osui-empty-small .ant-empty-image{height:50px;margin-bottom:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
